export default __webpack_public_path__ + "static/media/minionstart.662b1a08.png";